import { useBetslip } from "~/store/betslip";
import { useSettings } from "~/store/settings";

export interface ITaxConfig {
	SportId?: string;
	TaxCalculation?: string;
	TaxZero?: boolean;
	TaxPercentage: number;
	TaxType: "Wager" | "Winning" | "Payout" | null;
	TaxThresholdAmount: number;
}

export const getTaxConf = (paymentType: 1 | 2 | 4, sportId: string | false = false): ITaxConfig => {
	const settings = useSettings();
	const betslip = useBetslip();
	const route = useRoute();
	const selectedSportId = !sportId && betslip.isTrackRacingBetslip ? (betslip.events.get(betslip.selection[0]?.eventId)?.sportId as string) : sportId;
	if (!settings.config?.appSetting?.TaxSettings || paymentType === 4) {
		return { TaxPercentage: 0, TaxType: null, TaxThresholdAmount: 0 };
	}
	const taxConfig = settings.config?.appSetting?.TaxSettings.filter((x) =>
		selectedSportId ? x.SportId === selectedSportId : x.SportId === undefined
	);

	return taxConfig?.[0] ? taxConfig[0] : { TaxPercentage: 0, TaxType: null, TaxThresholdAmount: 0 };
};

export const calculatePayoutTax = (payoutAmount: number, taxConfig: ITaxConfig) => {
	const threshHoldAmount = taxConfig.TaxThresholdAmount || 0;
	const taxableAmount = Math.max(payoutAmount - threshHoldAmount, 0);
	return (taxableAmount * taxConfig.TaxPercentage) / 100;
};

export const calculateWinningTax = (returnAmount: number, wager: number, paymentType: 1 | 2 | 4, taxConfig: ITaxConfig) => {
	if (paymentType === 2) {
		if (returnAmount - (taxConfig.TaxThresholdAmount || 0) <= 0) return 0;
		return (returnAmount - (taxConfig.TaxThresholdAmount || 0)) * (taxConfig.TaxPercentage / 100);
	}
	if (returnAmount - wager - (taxConfig.TaxThresholdAmount || 0) <= 0) return 0;
	return (returnAmount - wager - (taxConfig.TaxThresholdAmount || 0)) * (taxConfig.TaxPercentage / 100);
};

export const calcWagerTax = (wager: number, paymentType: 1 | 2 | 4, taxConfig: ITaxConfig) => {
	if (paymentType !== 1) return 0;
	return (wager * taxConfig.TaxPercentage) / 100;
};

export const calculateTax = (returnAmount: number, wager: number, paymentType: 1 | 2 | 4) => {
	const taxConfig = getTaxConf(paymentType);

	if (!taxConfig) return 0;
	switch (taxConfig.TaxType) {
		case "Payout":
			return calculatePayoutTax(returnAmount, taxConfig);
		case "Winning":
			return calculateWinningTax(returnAmount, wager, paymentType, taxConfig);
		case "Wager":
			return calcWagerTax(wager, paymentType, taxConfig);
		default:
			return 0;
	}
};
